<template>
    <div>
        <div class="selectTypeBox">
            <el-radio-group v-model="selectType" @change="onChangeSelectType">
                <el-radio-button label="banner_pa_da">PA端大banner</el-radio-button>
                <el-radio-button label="banner_pa_x">PA端小banner</el-radio-button>
                <el-radio-button label="banner_ca_da">猎头端大banner</el-radio-button>
                <el-radio-button label="banner_ca_x">猎头端小banner</el-radio-button>
            </el-radio-group>
            <el-button type="primary" icon="el-icon-circle-plus-outline" class="addbtn"
                @click="addzw()">添加新banner</el-button>
        </div>
        <div class="box">
            <el-row>
                <el-col :span="10" v-for="(o, index) in list" :key="o" :offset="index > 0 ? 2 : 0">
                    <el-card :body-style="{ padding: '0px' }">
                        <img  :src="o.code" class="image">
                        <div style="padding: 14px;">
                            <span>{{ o.description }}</span>
                            <div class="bottom clearfix">
                                <el-button type="text" @click="delBanner(o.id)" class="button">删除</el-button>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <el-dialog :title="'添加banner'" :visible.sync="dialogFormVisible2">
            <el-form :model="form2">
                <el-form-item label="banner介绍" :label-width="formLabelWidth">
                    <el-input v-model="form2.description"></el-input>
                </el-form-item>
                <el-form-item label="banner跳转链接" :label-width="formLabelWidth">
                    <el-input v-model="form2.path"></el-input>
                </el-form-item>
                <el-form-item label="banner排序" :label-width="formLabelWidth">
                    <el-input type="number" v-model="form2.sort"></el-input>
                </el-form-item>
                <el-form-item label="banner图片" :label-width="formLabelWidth">
                    <el-upload :show-file-list="false" :key="selectType"
                        :style="'height: calc(' + 30 * bili[selectType][1] / bili[selectType][0] + 'vw)'"
                        class="avatar-uploader avatar-uploader1" drag action="1" :on-change="setFile" :auto-upload="false"
                        :limit="1" :on-remove="remove" ref="upload">
                        <img fit="cover" v-if="form2.bannerImageUrl &&
                            form2.bannerImageUrl.indexOf('https://images.qilinpin.cn/') >= 0
                            " :style="'height: calc(' + 30 * bili[selectType][1] / bili[selectType][0] + 'vw)'"
                            :src="form2.bannerImageUrl" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <my-cropper ref="myCropper" @getFile="getFile" @upAgain="upAgain"  @closeUp="closeUp"></my-cropper>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="
                    addBanner()
                    ">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
import MyCropper from './cropper.vue'
import OSS from 'ali-oss'
let client = new OSS({
    region: 'oss-cn-beijing',
    accessKeySecret: 'mPTRYqVIIWC8XxSeZqKFMPtFMWMfb5', // AccessKeySecret 去你的阿里云上控制台上找
    accessKeyId: 'LTAIvBaMapD5qPW9', // AccessKeyId 去你的阿里云上控制台上找
    bucket: 'linkedln',
    endpoint: 'images.qilinpin.cn',
    cname: true,
    secure: true,
})

export default {
    name: 'banner',
    props: {},
    components: { MyCropper },
    data() {
        return {
            formLabelWidth: '200',
            file: false,
            selectType: 'banner_pa_da',
            list: [],
            dialogFormVisible2: false,
            bili: {
                'banner_pa_da': [1862, 329],
                'banner_pa_x': [435, 145],
                'banner_ca_da': [1862, 329],
                'banner_ca_x': [435, 145],
            },
            form2: {
                bannerImageType: '',
                bannerImageUrl: '',
                description: '',
                path: '',
                sort: ''
            },
        }
    },
    watch: {

    },
    methods: {
        addzw: function () {
            this.form2 = {
                bannerImageType: this.selectType,
                bannerImageUrl: '',
                description: '',
                path: '',
                sort: ''
            }
            this.file = false
            this.dialogFormVisible2 = true
        },
        addBanner() {
            let that = this
            let url = ''
            url = Config.path + '/api/platform/bannerImage/add'
            this.form2.sort = Number(this.form2.sort)
            axios({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token'),
                },
                data: this.form2,
            })
                .then(function (response) {
                    // eslint-disable-next-line
                    console.log(response)
                    if (response.data.success === '1') {
                        that.dialogFormVisible2 = false
                        that.getbanner()
                    } else if (response.data.success === '111111') {
                        that.$router.push({
                            path: '/login',
                        })
                    } else {
                        that.$message({
                            message: response.data.message,
                            type: 'warning',
                        })
                    }
                })
                .catch(function (error) {
                    // eslint-disable-next-line
                    console.log(error)
                })
        },
        delBanner(id) {
            let that = this
            let url = ''
            url = Config.path + '/api/platform/bannerImage/del'
            axios({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token'),
                },
                data: {
                    id: id
                }
            })
                .then(function (response) {
                    // eslint-disable-next-line
                    console.log(response)
                    if (response.data.success === '1') {
                        that.getbanner()
                    } else if (response.data.success === '111111') {
                        that.$router.push({
                            path: '/login',
                        })
                    } else {
                        that.$message({
                            message: response.data.message,
                            type: 'warning',
                        })
                    }
                })
                .catch(function (error) {
                    // eslint-disable-next-line
                    console.log(error)
                })
        },
        getbanner() {
            let that = this
            let url = ''
            url = Config.path + '/api/platform/bannerImage/getBannerImagesList'
            let data = {
                bannerImageType: this.selectType,
            }
            axios({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token'),
                },
                data: data,
            })
                .then(function (response) {
                    // eslint-disable-next-line
                    console.log(response)
                    if (response.data.success === '1') {
                        let demo = response.data.content
                        that.list = demo
                    } else if (response.data.success === '111111') {
                        that.$router.push({
                            path: '/login',
                        })
                    } else {
                        that.$message({
                            message: response.data.message,
                            type: 'warning',
                        })
                    }
                })
                .catch(function (error) {
                    // eslint-disable-next-line
                    console.log(error)
                })
        },
        onChangeSelectType(e) {
            this.getbanner()
        },
        remove: function () {
            this.file = false
        },
        setFile: function (res) {
            debugger
            let that = this
            let file = res.raw
            this.$nextTick(() => {
                this.$refs.myCropper.open(file.raw || file, this.bili[this.selectType])
            })
        },
        getFile(file) {
            let that = this
            const formData = new FormData()
            formData.append('file', file)
            that.file = file
            that.uplaod()
        },
        closeUp() {
            debugger
            this.$refs.upload.clearFiles()//清空上传列表
        },
        upAgain() {
            this.$refs.upload.clearFiles() //清空上传列表
            this.$refs['upload'].$refs['upload-inner'].handleClick()
        },

        uplaod: function (res) {
            let that = this
            let str = this.random_string(32)
            client
                .multipartUpload('upload/' + str + '.png', this.file, {
                    progress: function (p) {
                        that.loading = true
                        console.log('Progress: ' + p)
                        that.p = p
                    },
                })
                .then((res) => {
                    that.loading = false
                    console.log(res)
                    that.$refs.myCropper.close()
                    that.form2.bannerImageUrl = 'https://images.qilinpin.cn/' + res.name
                })
                .catch((err) => {
                    that.loading = false
                    console.log(err)
                })
        },
        random_string: function (len) {
            len = len || 32
            var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
            var maxPos = chars.length
            var pwd = ''
            for (let i = 0; i < len; i++) {
                pwd += chars.charAt(Math.floor(Math.random() * maxPos))
            }
            return pwd
        },
        random_number: function (len) {
            len = len || 32
            var chars = '123456789'
            var maxPos = chars.length
            var pwd = ''
            for (let i = 0; i < len; i++) {
                pwd += chars.charAt(Math.floor(Math.random() * maxPos))
            }
            return pwd
        }
    },
    mounted: function () {
        this.getbanner();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.box{
    width: 90vw;
    margin: 0 auto;
}
.addbtn {
    margin-left: 100px;
}

.itemList {
    margin-top: 20px;
}

.itemList .itemDiv {
    background-color: #ffffff;
    width: 80%;
    margin: 0 auto 15px auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 25px;
    border-radius: 8px;
    min-height: 150px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.itemList .itemDiv .leftDiv {
    width: 70%;
}

.itemList .itemDiv .leftDiv p {
    font-size: 18px;
    color: #757373;
}

.itemList .itemDiv .leftDiv div {
    padding: 30px 0;
}

.itemList .itemDiv .rightDiv {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}

.itemList .itemDiv .rightDiv p {
    font-size: 32px;
    color: #1AAD19;
    text-align: center;
}

.itemList .itemDiv .rightDiv .active {
    color: red;
}

.itemList .itemDiv .rightDiv div {
    padding: 30px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.block {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
}

.demo-input-suffix>p {
    padding: 10px 0;
}

.reasShBox {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    position: fixed;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
}

.reasShBox>div {
    width: 30vw;
    height: 100vh;
    overflow: hidden;
    overflow-y: scroll;
}

.reasShBox>div>iframe {
    width: 100%;
    height: 100%;
}

.reasShBox>div:nth-child(1) {
    background-color: #ffffff;
    padding: 30px;
    box-sizing: border-box;
}

.reasShBox>div .title {
    padding: 10px 0;
    width: max-content;
    background-color: #cecece;
}

.reasShBox>div .cont {
    padding: 10px;
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-all;
}

.reasShBox .buttonBox {
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}



.time {
    font-size: 13px;
    color: #999;
}

.bottom {
    margin-top: 13px;
    line-height: 12px;
}

.button {
    padding: 0;
    float: right;
}

.image {
    width: 100%;
    display: block;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
}

.avatar-uploader {
    width: 30vw;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 30vw;

}

.avatar-uploader>.el-upload .el-upload-dragger {
    width: 30vw;

}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 30vw;
    display: block;
}
</style>
<style>
.avatar-uploader1 {
    margin: 0 auto;
}

.avatar-uploader1 .el-upload {
    width: 30vw;
    height: 100%;
}

.avatar-uploader1 .el-upload .el-upload-dragger {
    width: 30vw;
    height: 100%;
}

.avatar-uploader1 .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 30vw;
    height: 100%;
    line-height: 350%;
    text-align: center;
}
</style>
